import { render, staticRenderFns } from "./ProductDetail.vue?vue&type=template&id=1ba0056a&scoped=true&"
import script from "./ProductDetail.vue?vue&type=script&lang=ts&"
export * from "./ProductDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDetail.vue?vue&type=style&index=0&id=1ba0056a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba0056a",
  null
  
)

export default component.exports